import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'flex w-auto items-center gap-2 py-3 pr-1 pl-3',
    icon: 'text-contrast mb-auto flex size-8 min-w-8 items-center justify-center rounded-full border border-white',
    message: 'heading-xs text-text-main-inversion pr-2 font-medium',
    iconInner: ''
  },
  variants: {
    status: {
      success: {
        base: 'bg-label-brand',
        iconInner: '[&>path]:stroke-white'
      },
      error: 'bg-label-red'
    }
  },
  defaultVariants: {
    status: 'success'
  }
});
